import { styled } from '@components-shared/src/stitches';

export const MANUALLY_ADDED_ADDRESSES_HEADER = 'Manually added wallet addresses';
export const SELECTED_ARTISTS_COLLECTORS_HEADER = 'Collectors of selected artists';
export const SELECTED_RELEASES_COLLECTORS_HEADER = 'Collectors of selected releases';

export const Sections = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const Section = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginTop: 24,
  gap: 24,
  '.loadMore': { margin: '0 auto' },
  variants: {
    manuallyAdded: {
      true: {
        gap: 8,
      },
    },
  },
});

export const SectionHeader = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  p: {
    base: 'L',
    fontStyle: 'semibold',
  },
});

export const CollectorRows = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

export const Row = styled('div', {
  display: 'flex',
  gap: 16,
  variants: {
    center: {
      true: {
        alignItems: 'center',
      },
    },
  },
});

export const CollectorAndReleaseDetails = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
});

export const RowTitle = styled('div', {
  base: 'M',
  fontStyle: 'semibold',
});

export const RowSubTitle = styled('div', {
  base: 'S',
  textTransform: 'uppercase',
});

export const SubText = styled('div', {
  base: 'L',
  color: '$neutral500',
  marginBottom: 3,
});

export const Header = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export const ImageWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'black',
  borderRadius: 4,
  overflow: 'hidden',
  height: 40,
  width: 40,
  marginLeft: 2,
});
